import React, { useEffect, useState } from 'react'
import TableWrapper from '../../wrappers/tableWrapper'
import { CircularProgress, makeStyles, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@material-ui/core'
import CustomTableHeaderCell from '../../models/table/CustomTableHeaderCellPagination'
import { header } from './header';
import ExpandableRow from './ExpandableRow';

const useStyles = makeStyles((theme) => ({
  paper: {
    // height:'400px',
    minHeight: 'auto',
    maxHeight:'400px',
      width: '100%',
      boxShadow: 'none',
      border: '1px solid #C6C6C6',
    },
    table: {
      minWidth: 1200,
      width: '100%',
    },
    hidden: {
      [theme.breakpoints.down('lg')]: {
        display: 'none',
      },
    },
    inherited: {
      display: 'table-cell',
    },
    visuallyHidden: {
      border: 0,
      clip: 'rect(0 0 0 0)',
      height: 1,
      margin: -1,
      overflow: 'hidden',
      padding: 0,
      position: 'absolute',
      top: 20,
      width: 1,
    },
    labelHeader: {
      flexDirection: 'initial',
      '&:hover': {
        color: 'black',
      },
      '&:active': {
        color: 'black',
      },
    },
  }));

const ApprovedPurchaseOrderTable = (props) => {
    const classes = useStyles();
  const { loading, tableData, openPOLineDetails, errors, customizeTable, featuresAccess } = props;
  // const [customizeTable, setCustomizeTable] = useState([]);

  // useEffect(() => {
  //   setCustomizeTable([ 
  //     { active: false, id: 'poline', tableHeader: "PO - Line" },
  //     { active: false, id: 'dateOfDelivery', tableHeader: "Date of Delivery" },
  //     { active: true, id: 'dateOfCreation', tableHeader: "Date of Creation" },
    
  //     { active: true, id: 'poStatus', tableHeader: "PO Status" },
  //     { active: true, id: 'cdmoPlant', tableHeader: "CMO / CDMO - Plant ID" },
  //     { active: true, id: 'deliveredQty', tableHeader: "Delivered Qty. (%)" },
  //     { active: true, id: 'actions', tableHeader: "Actions" },
  //     { active: true, id: 'productCodeDescription', tableHeader: "Product Code / Description" },
  //     { active: true, id: 'viewBatches', tableHeader: "View Batches" },
  //   ])
  // },[])
  
  let tableColumn = header(localStorage.collabType !== "CMO", true, customizeTable,featuresAccess?.clickHereToViewBatches)

  return (
    <TableWrapper>
        <TableContainer component={Paper} className={classes.paper}>
        <Table
          stickyHeader
            id='poTable'
            className={classes.table}
            aria-label='collapsible table'
          >
            <TableHead>
              <TableRow>
                <TableCell
                  style={{
                    width: '1%',
                    maxWidth: 0,
                    overflow: 'hidden',
                  }}
                />

              {/* {header(localStorage.collabType !== "CMO", true, customizeTable).map((headCell) => (
                headCell.id == "viewBatches" && !featuresAccess?.clickHereToViewBatches ?
                   null
                  :<CustomTableHeaderCell
                    cellData={headCell}
                    key={headCell.id}
                    elementStyle={{
                      verticalAlign: 'top',
                      width: headCell.width ? headCell.width : 'auto',
                    }}
                  />
                ))} */}
              {tableColumn.map((headCell) => (
                <CustomTableHeaderCell
                    cellData={headCell}
                    key={headCell.id}
                    elementStyle={{
                      verticalAlign: 'top',
                      width: headCell.width ? headCell.width : 'auto',
                    }}
                  />
                ))}
              </TableRow>
            </TableHead>

            <TableBody>
              <React.Fragment>
                {loading === true ? (
                  <TableRow style={{ height: 150 }}>
                    <TableCell colSpan={tableColumn.length}>
                      <div style={{ textAlign: 'center' }}>
                        <CircularProgress color='primary' thickness={7} />
                      </div>
                    </TableCell>
                  </TableRow>
                          )
                              : errors.status === false ? (
                          <TableRow
                          style={{
                            border: '2px solid rgb(255,0,0)',
                            backgroundColor: 'rgb(255,240,240)',
                            Opacity: 1,
                            textAlign: 'center',
                            padding: '0.8rem',
                            fontSize: '0.875rem',
                          }}
                        >
                          <TableCell colSpan={tableColumn.length} align='center'>
                            {errors.errorDescription
                              ? errors.errorDescription
                              : 'Please try again'}
                          </TableCell>
                                  </TableRow> ):
                                  (tableData.length === 0) ? (
                  <TableRow>
                    <TableCell colSpan={tableColumn.length} align='center'>
                      No Records Found
                    </TableCell>
                  </TableRow>
                ) : (
                  tableData.map((row, i) => (
                    <Row
                      key={i}
                      row={row}
                      keys={i}
                      openPOLineDetails={openPOLineDetails}
                      customizeTable={customizeTable}
                    />
                  ))) 
            }
              </React.Fragment>
            </TableBody>
          </Table>
        </TableContainer>
      </TableWrapper>
  )
}

const Row = (props) => {
    return (
        <ExpandableRow
        openPOLineDetails={props.openPOLineDetails}
        row={props.row}
        keys={props.keys}
        customizeTable={props.customizeTable}
      />
    );
  }

export default ApprovedPurchaseOrderTable